import { Component } from 'react';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import Styles from './NSPagination.module.css';
import React from "react";
import { NSBoxCombo } from './NSBoxCombo';

export interface NSPaginationProps extends IBaseComponentProps
{
    totalItems: number;
    onPageChange: (page: number, size: number) => void;
}

interface NSPaginationState
{
    currentPage: number;
}

let pageSizes = [25, 50, 100, 200, 500];

export class NSPagination extends Component<NSPaginationProps, NSPaginationState>
{
    PageSize = React.createRef<NSBoxCombo>();
    constructor(props: NSPaginationProps)
    {
        super(props);
        this.state = { currentPage: 1 };
    }
    getCurrentPage(): number
    {
        return this.state.currentPage;
    }
    getPageSize(): number
    {
        let ans = this.PageSize.current?.getValue(false);
        if (!ans)
            ans = pageSizes[0].toString();
        return parseInt(ans as string);
    }
    override render()
    {
        let pageSize = this.getPageSize();
        const { totalItems, onPageChange } = this.props;
        const totalPages = Math.ceil(totalItems / pageSize);
        const windowSize = 2;
        const minPage = Math.max(2, this.state.currentPage - windowSize);
        const maxPage = Math.min(this.state.currentPage + windowSize, totalPages - 1);
        const current_min = Math.min(totalItems, (this.state.currentPage - 1) * pageSize + 1);
        const current_max = Math.min(totalItems, this.state.currentPage * pageSize);
        const pages: JSX.Element[] = [];

        const pushButton = (name: string, selected: boolean, onClick: () => void) =>
        {
            pages.push(
                <div key={name} className={`${Styles.ns_pagination_button_parent}`}>
                    <button
                        className={`${Styles.ns_pagination_button} ${selected ? Styles.ns_pagination_button_selected : ''}`}
                        onClick={(e) =>
                        {
                            e.preventDefault();
                            onClick();
                        }}
                    >
                        {name}
                    </button>
                </div>
            );
        };
        const pushPage = (page: number) =>
        {
            pushButton(page.toLocaleString(), page === this.state.currentPage, () =>
            {
                let currentPage = page;
                this.setState({ currentPage }, () =>
                {
                    let pageSize = this.getPageSize();
                    onPageChange(currentPage, pageSize);
                });
            });
        };
        const pushArrow = (key: string, logo: string, onClick: () => void) =>
        {
            pages.push(
                <div key={key} className={`${Styles.ns_pagination_button_parent}`}>
                    <button
                        className={Styles.ns_pagination_button}
                        onClick={e =>
                        {
                            e.preventDefault();
                            onClick();
                        }}
                    >
                        <img
                            src={logo}
                            alt={key}
                            width={32}
                            height={32}
                        />
                    </button>
                </div >
            );
        };
        // Previous
        pushArrow("previous", "https://static.namirasoft.com/image/concept/arrow/left/white-blue.svg", () =>
        {
            if (this.state.currentPage > 1)
            {
                let currentPage = this.state.currentPage - 1;
                this.setState({ currentPage }, () =>
                {
                    let pageSize = this.getPageSize();
                    onPageChange(currentPage, pageSize);
                });
            }
        });
        //FirstPage
        pushPage(1);
        if (this.state.currentPage > windowSize + 2)
        {
            pushButton("...", false, () => { });
        }
        for (let i = minPage; i <= maxPage; i++)
            pushPage(i);
        if (this.state.currentPage < totalPages - windowSize - 1)
        {
            pushButton("...", false, () => { });
        }
        //LastPage
        if (totalPages > 1)
        {
            pushPage(totalPages);
        }
        // Next
        pushArrow("next", "https://static.namirasoft.com/image/concept/arrow/right/white-blue.svg", () =>
        {
            if (this.state.currentPage < totalPages)
            {
                let currentPage = this.state.currentPage + 1;
                this.setState({ currentPage }, () =>
                {
                    let pageSize = this.getPageSize();
                    onPageChange(currentPage, pageSize);
                });
            }
        });
        return (
            <>
                <div
                    id={this.props.id}
                    className={`${Styles.ns_pagination_container} ${this.props.classList?.join(' ')}`}
                    style={this.props.style}
                >
                    <div className={Styles.ns_pagination_buttons_container}>
                        {pages}
                    </div>

                    <NSBoxCombo
                        ref={this.PageSize}
                        title=''
                        required={false}
                        searchable={false}
                        multiple={false}
                        defaultValue="25"
                        hideHeader
                        getOptions={() => pageSizes.map(pagesize => { return { value: pagesize.toString(), title: pagesize.toString() } })}
                        onChanged={() =>
                        {
                            let currentPage = this.state.currentPage;
                            this.setState({ currentPage }, () =>
                            {
                                let pageSize = this.getPageSize();
                                onPageChange(currentPage, pageSize);
                            });
                        }}
                        style={{ width: "70px" }}
                    />
                    <p className={Styles.ns_pagination_info}>
                        {`(${current_min.toLocaleString()} - ${current_max.toLocaleString()}) of ${totalItems.toLocaleString()}`}
                    </p>
                </div>
            </>
        );
    }
}